/**
 * 神策自定义埋点
 * https://xmkm.yuque.com/armee3/iu926w/yz3ht4
 */
export const reportToSensorsData = (event, data) => {
  const sensors = window.sensors || window.proxy?.sensors
  if (sensors) {
    window.sensors.track(event, data)
  } else {
    if (!window.sensorsTempData) {
      window.sensorsTempData = []
    }
    window.sensorsTempData.push({ event, data })
  }
}

/**
 * 上报页面停留时间
 * @param {} router
 */
export const pageViewDurationReport = ({ router }) => {
  let startTime = Date.now()
  let currentTime
  const reportLimitDuration = 5 * 60
  router.beforeEach((to, from, next) => {
    if (to) {
      if (from.path === to.path) {
        next()
        return
      }
      currentTime = Date.now()
      const interval = (currentTime - startTime) / 1000
      if (interval > reportLimitDuration || interval <= 0) {
        next()
        return
      }
      startTime = Date.now()
      reportToSensorsData('pageclose', {
        $url: window.location.href,
        $event_duration: interval,
      })
    }
    next()
  })
}
